import { render, staticRenderFns } from "./PlatDataGridSemester.vue?vue&type=template&id=3618a95c"
import script from "./PlatDataGridSemester.vue?vue&type=script&lang=js"
export * from "./PlatDataGridSemester.vue?vue&type=script&lang=js"
import style0 from "./PlatDataGridSemester.vue?vue&type=style&index=0&id=3618a95c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports